module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<style>\r\n    #dialog {\r\n        padding: 10px 15px;\r\n    }\r\n\r\n    .table {\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .btn-std-width {\r\n        width: 85px;\r\n        font-weight: normal;\r\n    }\r\n\r\n    .table td.fit {\r\n        white-space: nowrap;\r\n        width: 1%;\r\n        padding-top: 1px;\r\n        padding-bottom: 1px;\r\n    }\r\n\r\n    .fixed-size-100 {\r\n        max-width:100px;\r\n        min-width: 100px;\r\n        width: 100px;\r\n    }\r\n\r\n    .table-striped > tbody > tr:nth-of-type(odd) {\r\n        background: rgb(221, 221, 220);\r\n    }\r\n</style>\r\n\r\n<div id=\"dialog\" title=\"")
    ; __append(escapeFn(title))
    ; __append("\" >\r\n    <div class=\"row\" style=\"padding-bottom: 2px; display:flex; align-items:center;\">\r\n        <span for=\"stageChoice\" class=\"col-sm-2 control-label fixed-size-100\">Stage:</span>\r\n        <div class=\"col-sm-3\">\r\n             <select id=\"stageChoice\" name=\"stageChoice\" class=\"data-switch\">\r\n                ")
    ;  stages.map(function(stage){ 
    ; __append("\r\n                    <option value='")
    ; __append(escapeFn(stage.id))
    ; __append("'>")
    ; __append(escapeFn(stage.name))
    ; __append("</option>\r\n                ")
    ;  }) 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding-bottom: 2px; display:flex; align-items:center;\">\r\n        <span for=\"roleChoice\" class=\"col-sm-2 control-label fixed-size-100\">Role</span>\r\n        <div class=\"col-sm-3\">\r\n            <select id=\"roleChoice\" name=\"roleChoice\" class=\"data-switch\">\r\n                ")
    ;  roles.map(function(role){ 
    ; __append("\r\n                    <option value='")
    ; __append(escapeFn(role.id))
    ; __append("'>")
    ; __append(escapeFn(role.name))
    ; __append("</option>\r\n                ")
    ;  }) 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n    ")
    ;  if (actionSectionTitle.toLowerCase() === 'mandatory'){
    ; __append("\r\n    <div class=\"row\" style=\"display:flex; align-items:center;\">\r\n        <span for=\"mandatoryChoice\" class=\"col-sm-2 control-label fixed-size-100\">Mandatory:</span>\r\n        <div class=\"col-sm-3\">\r\n            <select id=\"mandatoryChoice\" name=\"mandatoryChoice\" class=\"data-switch\">\r\n                <option value='all'>All</option>\r\n                <option value='yes'>Yes</option>\r\n                <option value='no'>No</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    ")
    ; }
    ; __append("\r\n\r\n    ")
    ; if(showInputTable){
    ; __append("\r\n        <table id=\"stage-and-roles-table\" class=\"table table-condensed table-striped table-bordered\">\r\n            <thead>\r\n            <tr>\r\n                <th class=\"text-center\">\r\n                    <span class=\"content\">Object</span>\r\n                </th>\r\n                <th class=\"text-center fit\">\r\n                    <span class=\"content\">")
    ; __append(escapeFn(actionSectionTitle))
    ; __append("</span>\r\n                </th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            ")
    ; inputs.forEach(function(input){
                
    ; __append("\r\n                <tr>\r\n                    <td>\r\n                        <span class=\"content\">\r\n                            ")
    ; __append(escapeFn(input.name))
    ; __append("\r\n                        </span>\r\n                    </td>\r\n                    <td class=\"fit\">\r\n                        <select class=\"setting btn-std-width\" data-object-id=\"")
    ; __append(escapeFn(input.id))
    ; __append("\">\r\n                            ")
    ; options.forEach(function(option){
                            
    ; __append("\r\n                            <option value=\"")
    ; __append(escapeFn(option.value))
    ; __append("\" ")
    ; __append(escapeFn((input.state === option.value) ? 'selected="selected"' : ''))
    ; __append(" >")
    ; __append(escapeFn(option.label))
    ; __append("</option>\r\n                            ")
    ; 
                            })
    ; __append("\r\n                        </select>\r\n                    </td>\r\n                </tr>\r\n                ")
    ; 
            })
    ; __append("\r\n            </tbody>\r\n        </table>\r\n    ")
    ; }else{
    ; __append("\r\n    ")
    ; __append(escapeFn(emptyTitle))
    ; __append("\r\n    ")
    ; }
    ; __append("\r\n    <div>\r\n\r\n    </div>\r\n</div>")
  }
  return __output;

}